import {TYPES} from '../Actions/configAction';

const configReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.FETCH_MAINTENANCE_TIME_SUCCESS:
            return {
                ...state,
                maintenanceTime: action.maintenanceTime
            };
        default:
            return state;
    }
};

export default configReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/configReducer.ts